import { ArrowLeftOutlined } from "@ant-design/icons";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import { Box, Button, ButtonGroup, Stack, Typography } from "@mui/material";
import { AxisMapped, ReportDto } from "interfaces/report";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import PrintReport from "./PrintReport";

interface Props {
  report: ReportDto<AxisMapped>;
  setOpenSharedEmailsDialog: Function;
  isOwner: boolean;
  revisionMode: boolean;
}
export const ComponentToPrint = React.forwardRef((props: any, ref) => {
  if (props.showPrint) {
    return (
      // @ts-ignore
      <div ref={ref}>
        <PrintReport report={props.report} />
      </div>
    );
  }
  return <></>;
});
export default function HeaderAction({
  report,
  isOwner,
  setOpenSharedEmailsDialog,
  revisionMode,
}: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const [showPrint, setShowPrint] = useState(false);
  const navigate = useNavigate();
  const componentRef = useRef<any>();
  const handlePrint = useReactToPrint({
    // @ts-ignore
    content: () => componentRef.current,
    onAfterPrint: () => {
      setShowPrint(false);
      setIsLoading(false);
    },
  });

  return (
    <div>
      <ComponentToPrint
        showPrint={showPrint}
        ref={componentRef}
        report={report}
      />

      <Box
        alignItems="center"
        justifyContent="space-between"
        display="flex"
        flexWrap="wrap"
        position="relative"
      >
        <Stack spacing={1} direction="row" alignItems="center">
          <Box
            onClick={() => navigate("/reports")}
            style={{ cursor: "pointer" }}
          >
            <ArrowLeftOutlined />
          </Box>
          <Typography
            variant="h3"
            style={{
              maxWidth: "60vw",
            }}
          >
            {report.name}
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="flex-end"
          spacing={1}
          style={{
            position: "fixed",
            right: 15,
            top: 75,
            zIndex: 100,
          }}
        >
          {revisionMode && (
            <Box display="flex" justifyContent="flex-end">
              <Button
                startIcon={<ExitToAppIcon />}
                variant="contained"
                size="medium"
                color="secondary"
                onClick={() => navigate(`/reports/${report._id}/revisions`)}
              >
                Exit Revision Mode
              </Button>
            </Box>
          )}

          <ButtonGroup
            variant="contained"
            style={{
              boxShadow: "unset",
              justifyContent: "flex-end",
            }}
          >
            <Button
              startIcon={<PictureAsPdfIcon />}
              variant="contained"
              color="primary"
              onClick={() => {
                setIsLoading(true);
                setShowPrint(true);

                setTimeout(() => {
                  handlePrint();
                }, 6000);
              }}
              style={{
                fontWeight: 700,
                cursor: isLoading ? "not-allowed" : "pointer",
                pointerEvents: isLoading ? "none" : "initial",
              }}
            >
              {isLoading ? "Printing...." : "PDF"}
            </Button>
            <Button
              onClick={() => setOpenSharedEmailsDialog(true)}
              startIcon={<SupervisedUserCircleIcon />}
              variant="contained"
              color="primary"
              style={{ fontWeight: 700 }}
            >
              Shared
            </Button>
            {isOwner && (
              <Button
                startIcon={<EditIcon />}
                variant="contained"
                color="primary"
                style={{
                  fontWeight: 700,
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                }}
                onClick={() => navigate(`/reports/${report._id}/edit`)}
              >
                Update
              </Button>
            )}
          </ButtonGroup>
        </Stack>
      </Box>
    </div>
  );
}
